/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { custom } from '@gh/core-data';
import { FormulaDto, getFormulaParams } from './formula.dto';

export const FormulaMapper = custom({
  serialize: (formula: FormulaDto) => formula && formula.expression || void 0,
  deserialize: (expression?: string) => ({
    expression: expression || '',
    takeOffParams: getFormulaParams(expression || ''),
    valid: true,
  }),
});
